import { type Dispatch, type RefObject } from 'react'

import { type Action, type MessagesWizard } from '#types/chat/index.ts'
import { createConversation } from './createConversation.ts'
import { submitMessage } from './submitMessage.ts'

interface OnSubmitProps {
	currentFormContext?: { wiserBotMessage: string }
	showEmptyChat: boolean
	textareaRef: RefObject<HTMLTextAreaElement>
	dispatch: Dispatch<Action>
	messageFetcher: any
	conversationId: string | undefined
	messages?: MessagesWizard
	typeOfView: string
}

export const onSubmit = async ({
	currentFormContext,
	showEmptyChat,
	textareaRef,
	dispatch,
	messageFetcher,
	conversationId,
	messages,
	typeOfView,
}: OnSubmitProps) => {
	if (showEmptyChat) {
		if (messages) {
			createConversation({
				messages: messages,
				dispatch,
				messageFetcher,
				typeOfView,
			})
		}

		if (currentFormContext) {
			createConversation({
				message: currentFormContext.wiserBotMessage,
				dispatch,
				messageFetcher,
				typeOfView,
			})
		}

		textareaRef.current!.value = ''
	}

	if (!showEmptyChat && conversationId && currentFormContext) {
		submitMessage({
			message: currentFormContext.wiserBotMessage,
			messageFetcher,
			conversationId,
			dispatch,
			typeOfView,
		})

		textareaRef.current!.value = ''
	}
}

export const onInvalid = (data: any) => {}
